import { render, staticRenderFns } from "./EditMemberDetail.vue?vue&type=template&id=64e700ac&"
import script from "./EditMemberDetail.vue?vue&type=script&lang=js&"
export * from "./EditMemberDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports